import { Card, Col, Divider, Row, Space, Typography } from "antd";
import { partners } from "./constants";

const { Meta } = Card;

const { Title } = Typography;

const PartnersPage = () => {
  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Samarbeidspartnere</Title>
      </Space>
      <Divider />
      <Row gutter={[15, 15]}>
        {Object.entries(partners).map(([partner, partnerInfo]) => (
          <Col key={partner} md={24} lg={12}>
            <Card key={partner} style={{ height: "100%" }}>
              <Row justify="center" align="middle" style={{ height: "200px" }}>
                <a href={partnerInfo.url} target="_blank" rel="noopener noreferrer">
                  <img
                    alt={partner}
                    src={document.body.getAttribute("data-theme") === "dark" ? partnerInfo.whiteLogo : partnerInfo.logo}
                    width="200em"
                  />
                </a>
              </Row>
              <Meta title={<Title level={4}>{partner}</Title>} description={partnerInfo.description} />
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default PartnersPage;
